(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name aircraftRegistration.controller:AircraftRegistrationCtrl
   *
   * @description
   *
   */
  angular
    .module('aircraftRegistration')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('AircraftRegistrationCtrl', AircraftRegistrationCtrl);

  function AircraftRegistrationCtrl(EventManagerService,CommonMasterData,AircraftRegistrationService,applicationConstants,CommonFuelService,PopupManager,MessageService) {
    var vm = this;
    vm.ctrlName = 'AircraftRegistrationCtrl';
    vm.showRightPanel = false;
    vm.model = {
            initialSearchDone: false,
            editorMode:applicationConstants.EDITOR_STATUS.ADD,
    		searchPanelToggle:true,
            searchCriteria:{

            	acModel:null,
            	aircraftRegName:null,
            	inActiveStartDate:null,
            	inActiveEndDate:null,
            	etop:null,
            	sharklets:null,
            	capacity :null,
            	status :null
            },
            aircraftList:[],
            masterList:{
            	acModelList:[],
            	airportList:[],
            	statusList:[],
            	INAStartInvalidInSearch : false,
            	INAEndInvalidInSearch : false,
            	INAStartAfterEndDateInSearch : false,
            	INAStartInvalidInEdit : false,
            	INAEndInvalidInEdit : false,
            	INAStartAfterEndDateInEdit : false,
              acmiTypes : []
            },
            selectedAirCraft :null
        };



    vm.clickOnSearch = function () {
        vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
        vm.model.initialSearchDone=false;
    };

    vm.changeSearchField = function(searchParams,flag){
    	if(flag == 'inActiveStartDate' || flag == 'inActiveEndDate'){
    		setDateValidationFlagsInSearch();
    	}
    };

    vm.changeEditorField = function (flag, operation, selectedItems) {
    	if(flag === 'modelNumber'){
    		AircraftRegistrationService.getCapacity(selectedItems.modelNumber,
    		function (response) {
    			if(vm.model.selectedAirCraft=== null){
    				vm.model.selectedAirCraft = AircraftRegistrationService.getNewReg();
    			}
    			vm.model.selectedAirCraft.capacity = response.capacity;
    		},function (error) {
                MessageService.error(error);
            }

    		);
    	} else if(flag.indexOf('inActiveStartDate') != -1 || flag.indexOf('inActiveEndDate') != -1){
    		var changedPeriodIndex = getChangedInactivePeriodIndex(flag, 1);
    		if(flag.indexOf('inActiveStartDate') != -1){
    			autoSetToDate(vm.model.selectedAirCraft.aircraftInactivePeriods, changedPeriodIndex);
    		}
    		setDateValidationFlagsInEdit(vm.model.selectedAirCraft.aircraftInactivePeriods, changedPeriodIndex);
    	}else if(flag.indexOf('newInactiveStartDate') != -1 || flag.indexOf('newInactiveEndDate') != -1){
    		var changedPeriodIndex = getChangedInactivePeriodIndex(flag, 1);
    		if(flag.indexOf('newInactiveStartDate') != -1){
    			autoSetToDate(vm.model.selectedAirCraft.newlyAddedInactivePeriods, changedPeriodIndex);
    		}
    		setDateValidationFlagsInEdit(vm.model.selectedAirCraft.newlyAddedInactivePeriods, changedPeriodIndex);
    	}
    }

    function getChangedInactivePeriodIndex(flag, indexAt){
    	var index = -1;
    	var arr = flag.split("_");
    	if(arr.length >= indexAt){
    		index = arr[indexAt];
    	}
    	return index;
    }

    vm.searchAcRegistration = function (params) {
    	setDateValidationFlagsInSearch();
        if(isValidSearchParams()){
        	vm.model.initialSearchDone=true;
            vm.model.aircraftList = [];
            vm.model.searchCriteria.pageSize = 100000;
            vm.model.searchCriteria.startPosition = 1;
            AircraftRegistrationService.setAcRegSearchCriteria(vm.model.searchCriteria);
            AircraftRegistrationService.getAcRegistration(
            		function (aircraftList) {
                        updateReg(aircraftList);
                        vm.model.searchPanelToggle = false;
                        vm.clickOnCloseAirCraft();
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
        }
    };

    function isValidSearchParams(){
    	if(!vm.model.masterList.INAStartInvalidInSearch &&
    			!vm.model.masterList.INAEndInvalidInSearch &&
    			!vm.model.masterList.INAStartAfterEndDateInSearch){
    		return true;
    	}
    	return false;
    }

    function isDateFormatInvalid(date){
		if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
			return true;
		}
		return false;
	}


	// check from date and to date
	function istoDateBeforeFromDate(fromDate, toDate) {
		return moment(toDate, "DD/MM/YYYY")
				.isBefore(
						moment(fromDate,
								"DD/MM/YYYY"));
	}
	;

	function setDateValidationFlagsInSearch(){
		//if from date invalid
		if(isDateFormatInvalid(vm.model.searchCriteria.inActiveStartDate)){
			vm.model.masterList.INAStartInvalidInSearch = true;
		}else{
			vm.model.masterList.INAStartInvalidInSearch = false;
		}

		//if to date invalid
		if(isDateFormatInvalid(vm.model.searchCriteria.inActiveEndDate)){
			vm.model.masterList.INAEndInvalidInSearch = true;
		}else{
			vm.model.masterList.INAEndInvalidInSearch = false;
		}
		//check INAStart date is after INAEnd date
		if(!!vm.model.searchCriteria.inActiveStartDate && !vm.model.masterList.INAStartInvalidInSearch &&
			!!vm.model.searchCriteria.inActiveEndDate && !vm.model.masterList.INAEndInvalidInSearch	&&
			istoDateBeforeFromDate(vm.model.searchCriteria.inActiveStartDate, vm.model.searchCriteria.inActiveEndDate)){
			vm.model.masterList.INAStartAfterEndDateInSearch = true;
		} else {
			vm.model.masterList.INAStartAfterEndDateInSearch = false;
		}
	}

	function autoSetToDate(acInactPeriods, index){
		if(!!acInactPeriods[index] && !!acInactPeriods[index].inActiveStartDate){
			acInactPeriods[index].inActiveEndDate = angular.copy(acInactPeriods[index].inActiveStartDate);
		}
	}

    function setDateValidationFlagsInEdit(acInactPeriods, index){
    	var flagSettingList = [];
    	if(index == -1){
    		flagSettingList = acInactPeriods;
    	} else {
    		flagSettingList.push(acInactPeriods[index]);
    	}
    	angular.forEach(flagSettingList, function (period) {
    		//if from date invalid
    		if(isDateFormatInvalid(period.inActiveStartDate)){
    			period.INAStartInvalidInEdit = true;
    		}else{
    			period.INAStartInvalidInEdit = false;
    		}

    		//if to date invalid
    		if(isDateFormatInvalid(period.inActiveEndDate)){
    			period.INAEndInvalidInEdit = true;
    		}else{
    			period.INAEndInvalidInEdit = false;
    		}

    		//check INAStart date is after INAEnd date
    		if(  !!period.inActiveStartDate && !period.INAStartInvalidInEdit &&
    			!!period.inActiveEndDate && !period.INAEndInvalidInEdit	&&
    			istoDateBeforeFromDate(period.inActiveStartDate, period.inActiveEndDate)){
    			period.INAStartAfterEndDateInEdit = true;
    		} else {
    			period.INAStartAfterEndDateInEdit = false;
    		}


    		if(!!period.inActiveStartDate && !period.INAStartInvalidInEdit && !period.INAStartAfterEndDateInEdit
    				&& !period.isPastInaStartDate && isPastDate(period.inActiveStartDate)){
    			period.isInaStartSetToPast = true;
    		} else {
    			period.isInaStartSetToPast = false;
    		}

    		if(!!period.inActiveEndDate && !period.INAEndInvalidInEdit && !period.INAStartAfterEndDateInEdit
    				&& !period.isPastInaEndDate && isPastDate(period.inActiveEndDate)){
    			period.isInaEndSetToPast = true;
    		} else {
    			period.isInaEndSetToPast = false;
    		}
        });
	}

    function isPastDate(date){
    	return moment(date, "DD/MM/YYYY").isBefore(moment(new Date()).startOf('day'));
    }

    function updateReg(aircraftList) {
        angular.forEach(aircraftList, function (acReg) {
            vm.model.aircraftList.push(acReg);
        });
    }


    vm.selectAAcReg = function (selectedRowData) {
        vm.model.selectedAirCraft = AircraftRegistrationService.getAircraftForEdit(selectedRowData,vm.model.masterList.acModelList);
        vm.showRightPanel = true;
    };

    vm.submitAircraftRegistration = function (action, selectedItem) {
    	vm.model.selectedAirCraft = selectedItem;
    	setDateValidationFlagsInEdit(selectedItem.aircraftInactivePeriods, -1);
    	setDateValidationFlagsInEdit(selectedItem.newlyAddedInactivePeriods, -1);
    	if(isValidSaveParams(selectedItem.aircraftInactivePeriods) &&
    			isValidSaveParams(selectedItem.newlyAddedInactivePeriods)){
    		if (action === applicationConstants.EDITOR_STATUS.DELETE){
                var param = {
                    title: 'Confirmation',
                    messages: ["Do you want to delete this record"],
                    flags: selectedItem
                };
                PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
            } else {
                saveAcRegistration();
            }
    	}
    };

    vm.actionOnInactivePeriods = function (flag){
    	if(flag == 'ADD_NEW_INA_PERIOD'){
    		var newINAPeriod = AircraftRegistrationService.getNewAcRegPeriod();
    		vm.model.selectedAirCraft.newlyAddedInactivePeriods.push(newINAPeriod);
    	} else if (flag.indexOf('REMOVE_OLD_') != -1){
    		var removeElementIndex = getChangedInactivePeriodIndex(flag, 2);
    		removeInactivePeriod(vm.model.selectedAirCraft.aircraftInactivePeriods, removeElementIndex);
    	} else if (flag.indexOf('REMOVE_NEW_') != -1){
    		var removeElementIndex = getChangedInactivePeriodIndex(flag, 2);
    		removeInactivePeriod(vm.model.selectedAirCraft.newlyAddedInactivePeriods, removeElementIndex);
    	}
    }

    function removeInactivePeriod(inactivePeriods, index){
		if (index > -1) {
			inactivePeriods.splice(index, 1);
		}
    }

    function saveAcRegistration() {
    	AircraftRegistrationService.saveAcRegistration(vm.model.selectedAirCraft,
	            function (response) {
    				vm.model.selectedAirCraft.rotationUnassignPeriods = response.inaPeriodsWithAssignFlights;
    				if(response.success){
	                    MessageService.success('Successfully saved the record!');
	                    vm.searchAcRegistration(vm.model.searchCriteria);
	                    vm.addNewReg();
	                } else {
	                	if(response.inaPeriodsWithAssignFlights.length > 0){
	                		PopupManager.openModal(
									'UNASSIGN_ROTATION_CONFIRMATION_POPUP',
									response.inaPeriodsWithAssignFlights,
									confirmUnassignRotation);
	                	}
	                }
	            },
	            function (error) {
	                MessageService.error(error);
	            }
	        );
    }

    function confirmUnassignRotation(flag){
    	if(flag == 'YES'){
    		vm.model.selectedAirCraft.userConfirmUnassignFlightRotation = true;
    		saveAcRegistration();
    	} else {
    		vm.model.selectedAirCraft.userConfirmUnassignFlightRotation = false;
    	}
    }

    function isValidSaveParams(inactivePeriods){
    	for(var index in inactivePeriods) {
    		if(inactivePeriods[index].INAStartInvalidInEdit || inactivePeriods[index].INAEndInvalidInEdit ||
    				inactivePeriods[index].INAStartAfterEndDateInEdit || inactivePeriods[index].isInaEndSetToPast){
        		return false;
        	}
        }
    	return true;
    }

    function confirmDeleteDialog(pass) {
        if(pass === 'YES'){
        	AircraftRegistrationService.deleteAcRegistration(vm.model.selectedAirCraft,
                function (response) {
                    MessageService.success('Successfully deleted the record!');
                    vm.searchAcRegistration();
                    vm.addNewReg();
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }
    }

    vm.clickOnCloseAirCraft = function() {
      vm.showRightPanel = false;
      clearEditPanal();
    };

    function clearEditPanal(){
    	vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
        vm.model.selectedAirCraft = AircraftRegistrationService.getNewReg();
    }

    vm.addNewReg = function () {
        vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
        vm.model.selectedAirCraft = AircraftRegistrationService.getNewReg();
        vm.model.selectedAirCraft.status = true;
        vm.showRightPanel = true;
    };

    //load acModel list
    CommonMasterData.getAircraftTypeList(function (acModelList) {
        vm.model.masterList.acModelList = acModelList;
        vm.model.masterList.statusList = CommonFuelService.getStatusList();
        vm.model.searchCriteria.status = CommonFuelService.getDefaultStatus();
    }, function () {
    });

    CommonMasterData.getAirportList(function (response) {
    	vm.model.masterList.airportList = response;
    },function (error) {});

    CommonMasterData.getACMITypesList(function (acmiTypes) {
                    vm.model.masterList.acmiTypes = acmiTypes;
                }, function (error) {

                });

  }
}());
